import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scFilter'
})
export class SABISArrayFilterPipe implements PipeTransform {

  /**
   * Filter given array by property value
   * @param items Array items
   * @param filterByProperty Property to filter by
   * @param filterValue Filter value
   * @param includeFilterValue Include or exclude value from items
   * @returns filtered array items
   */
  transform(items: Array<any>, filterByProperty: string, filterValue: number | string | null, includeFilterValue: boolean): Array<any> {
    if (!items || !filterByProperty || !filterValue) {
      return items;
    }

    if(typeof filterValue == "number"){
      if(!includeFilterValue){
        return (items as Array<any>).filter((item) => item[filterByProperty] !== filterValue);
      }
      return (items as Array<any>).filter((item) => item[filterByProperty] === filterValue);
    }

    if(!includeFilterValue) {
      return (items as Array<any>).filter((item) => !item[filterByProperty].toLowerCase().includes(filterValue.toLowerCase()));
    }

    return (items as Array<any>).filter((item) => item[filterByProperty].toLowerCase().includes(filterValue.toLowerCase()));
  }
}
